






































import { Component } from '@niknevis/vue-modules'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import Heading from '@/modules/common/layout/components/shared/Heading.vue'
import BaseCard from '@/modules/shared/components/shared/base/BaseCard.vue'
import WebUserAuthCard from '@/modules/user/components/web/auth/WebUserAuthCard.vue'
import Checkbox from '@/modules/shared/components/shared/kit/Checkbox.vue'
import Copyright from '@/modules/shared/components/panel/Copyright.vue'
import Logo from '@/modules/shared/components/shared/Logo.vue'
import AlertNotification from '@/modules/notification/components/panel/AlertNotification.vue'
import PinInput from '@/modules/shared/components/panel/PinInput.vue'
import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import WebLayout from '@/modules/common/layout/components/web/WebLayout.vue'
import { UserPhoneVerifyRequestModel } from '@/modules/user/models/user-request.model'
import { AuthService } from '@/modules/user/services/auth.service'
import { PanelLayoutRoute } from '@/modules/common/layout/routes/panel-layout.route'


@Component({
  layout: WebLayout,
  metaInfo: {
    title: 'تایید تلفن همراه'
  },
  components: {
    PinInput,
    AlertNotification, Logo, Copyright, Checkbox, WebUserAuthCard, BaseCard, Heading, BaseInput, BaseButton
  }
})
export default class PhoneVerifyPage extends Vue {
  constructor(
    private readonly routes: PanelLayoutRoute,
    private readonly services: AuthService
  ) {
    super()
  }

  @Prop() info: { phone: string, skip_url: string }
  verifyPhoneModel: UserPhoneVerifyRequestModel = {
    phone: this.info.phone,
    verification_code: ''
  }


  verifyPhone(code) {
    this.verifyPhoneModel.verification_code = code
    this.services.phoneVerifyPageVerification(this.verifyPhoneModel)
  }

}
